"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.select = exports.input = exports.label = exports.buttons = exports.colors = exports.space = void 0;
var space = function (factor) {
    if (factor === void 0) { factor = 1; }
    return factor * 4;
};
exports.space = space;
exports.colors = {
    primary: "#009D9C",
    primaryDark: "#2F4858",
    primaryLight: "#3ED696",
    onPrimary: "white",
    delete: "#a00",
    subtle: "#eaeaea",
    neutral100: "#171717",
    neutral90: "#262626",
    neutral80: "#404040",
    neutral70: "#525252",
    neutral60: "#737373",
    neutral50: "#a3a3a3",
    neutral40: "#d4d4d4",
    neutral30: "#e6e6e6",
    neutral20: "#f5f5f5",
    neutral10: "#fafafa",
};
var button = {
    "--button-color": exports.colors.primary,
    "--on-button-color": exports.colors.onPrimary,
    "--button-hover-color": exports.colors.primaryDark,
    "--on-button-hover-color": "var(--on-button-color)",
    padding: (0, exports.space)(2),
    background: "var(--button-color)",
    color: "var(--on-button-color)",
    textAlign: "center",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "133ms all ease-in-out",
    outline: "none",
    border: "none",
    "&:hover": {
        color: "var(--on-button-hover-color)",
        background: "var(--button-hover-color)",
    }
};
exports.buttons = {
    primary: button,
    secondary: __assign(__assign({}, button), { "--button-color": exports.colors.neutral20, "--button-hover-color": exports.colors.neutral30, "--on-button-color": exports.colors.primary, "--on-button-hover-color": exports.colors.primaryDark, fontWeight: "normal" }),
    text: __assign(__assign({}, button), { "--button-color": "transparent", "--button-hover-color": exports.colors.neutral20, "--on-button-color": exports.colors.primary, "--on-button-hover-color": exports.colors.primaryDark }),
    outline: __assign(__assign({}, button), { "--button-color": "transparent", "--button-hover-color": exports.colors.neutral20, "--on-button-color": exports.colors.primary, "--on-button-hover-color": exports.colors.primaryDark, border: "1px solid " + exports.colors.primary, fontWeight: "normal" }),
    error: __assign(__assign({}, button), { "--button-color": "#D32F2F", "--on-button-color": "white", "--button-hover-color": "#C62828", fontWeight: "normal" })
};
exports.label = {
    fontSize: "0.8em",
    lineHeight: "1.4em",
    color: exports.colors.neutral70,
};
exports.input = {
    padding: (0, exports.space)(2),
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: exports.colors.neutral40,
    backgroundColor: "white",
    borderRadius: 2,
    appearance: "none",
    boxSizing: "border-box",
    margin: 0,
    "&:focus, &:focus-visible, &:active": {
        outlineColor: exports.colors.primary,
        borderColor: exports.colors.primary,
    }
};
exports.select = __assign(__assign({}, exports.input), { backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xNDA4IDcwNHEwIDI2LTE5IDQ1bC00NDggNDQ4cS0xOSAxOS00NSAxOXQtNDUtMTlMNDAzIDc0OXEtMTktMTktMTktNDV0MTktNDUgNDUtMTloODk2cTI2IDAgNDUgMTl0MTkgNDV6Ii8+PC9zdmc+")', backgroundSize: "16px auto", backgroundRepeat: "no-repeat", backgroundPosition: "100%", backgroundOrigin: "content-box", cursor: "pointer", minWidth: 80, width: "100%", "&:invalid": {
        color: "red",
    } });
